module.exports = __webpack_public_path__ + "static/media/medio_camion.31491226.svg";